module.exports = __webpack_public_path__ + "img/9_en.54ff412e.png";